// extracted by mini-css-extract-plugin
export default {"domainSelectWrapper":"BusinessSSOEmailAddressDomain_domainSelectWrapper__VmRbk","textButton":"BusinessSSOEmailAddressDomain_textButton__y5HcJ"};